import { Injectable } from '@angular/core';
import { EncryptStorage } from 'encrypt-storage';
import { environment } from '../../environments/environment.development';
@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private storage = new EncryptStorage(environment.storage_key, {
    doNotEncryptValues: false,
  });
  private sessionStorage = new EncryptStorage(environment.storage_key, {
    storageType: 'sessionStorage',
    doNotEncryptValues: true,
  });

  getItem(key: string, session: boolean = false) {
    try {
      return (session ? this.sessionStorage : this.storage).getItem(key);
    } catch (err) {
      console.warn(err, 'storage err');
      this.clear();
      return null;
    }
  }
  setItem(key: string, value: any, session: boolean = false) {
    (session ? this.sessionStorage : this.storage).setItem(key, value);
  }
  clear() {
    this.storage.clear();
    localStorage.clear();
    sessionStorage.clear();
  }
  encryptValue(value: any) {
    return this.storage.encryptValue(value);
  }
  decryptValue(value: any) {
    return this.storage.decryptValue(value);
  }
  removeItem(key: string, session: boolean = false) {
    return (session ? this.sessionStorage : this.storage).removeItem(key);
  }

  constructor() {}
}
